import client from './client';

export type StaffRole = 'admin' | 'moderator' | 'operator';

export interface StaffMember {
  id: string;
  email: string | null;
  full_name: string | null;
  phone: string | null;
  role: StaffRole | string;
  role_label: string;
  is_active: boolean;
  /** Задал ли человек пароль по ссылке из письма. */
  has_password: boolean;
  last_login_at: string | null;
  created_at: string | null;
  /** Приходит только сразу после создания/сброса — на случай, если письмо не дошло. */
  invite_link?: string | null;
  mail_sent?: boolean | null;
}

export interface StaffCreatePayload {
  email: string;
  full_name: string;
  role: StaffRole;
  phone?: string;
}

export const staffApi = {
  list: () => client.get<StaffMember[]>('/api/admin/staff'),

  create: (data: StaffCreatePayload) => client.post<StaffMember>('/api/admin/staff', data),

  update: (
    id: string,
    data: Partial<{ full_name: string; role: StaffRole; phone: string; is_active: boolean }>,
  ) => client.patch<StaffMember>(`/api/admin/staff/${id}`, data),

  /** Выслать ссылку на смену пароля. */
  sendReset: (id: string) =>
    client.post<{ invite_link: string; mail_sent: boolean }>(
      `/api/admin/staff/${id}/reset-password`,
    ),

  /** Отозвать доступ (человек остаётся в базе как житель). */
  revoke: (id: string) => client.delete(`/api/admin/staff/${id}`),
};

export const ROLE_OPTIONS: { value: StaffRole; label: string; hint: string }[] = [
  { value: 'admin', label: 'Администратор', hint: 'Всё, включая сотрудников и аналитику' },
  { value: 'moderator', label: 'Модератор', hint: 'Контент и модерация, без раздачи доступов' },
  { value: 'operator', label: 'Оператор', hint: 'Обращения и повседневная работа' },
];
